import { render, staticRenderFns } from "./MessageNotifications.vue?vue&type=template&id=2c294376&scoped=true"
import script from "./MessageNotifications.vue?vue&type=script&lang=js"
export * from "./MessageNotifications.vue?vue&type=script&lang=js"
import style0 from "./MessageNotifications.vue?vue&type=style&index=0&id=2c294376&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c294376",
  null
  
)

export default component.exports